import script from "./verifyemail.vue?vue&type=script&setup=true&lang=js"
export * from "./verifyemail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__